import DataGrid2 from '../../..';
import { IComboBoxProperties } from '../../../../ComboBox/entities/IComboBoxProperties';
import { iconTextRenderer } from '../iconTextRenderer';

export function CellComponent(props) {
	const dataGrid: DataGrid2 = props.data.column.retrieveDataGridInstance();
	const bcColumn = dataGrid.__getBCColumn<IComboBoxProperties>(props.data.column.name);

	const item = bcColumn.editControl.items.find(item => item.value === props.data.value);

	return iconTextRenderer(props.data.text, item?.icon);
}
